// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"delete-app-confirm_deleteIcon__3CJBt"};